module.exports = __webpack_public_path__ + "img/img0.4b18e68e.jpg";